import { CA_LIGHT_BLUE_COLOR, LIGHT_TEXT_PRIMARY } from '@utils/colorGenerator';
import { baseChart } from './baseChart';
import { NameValuePair } from '@components/Dashboard/SalesAttribution/SalesAttributionView/Summary/SalesDonutChart/salesDonutChart';
import { NameValuePairWithSortIndex } from '@components/Dashboard/CampaignAnalytics/slice/schema';
import { SUBHEADER_FONT_SIZE } from '@components/shared/Layout/ReportSectionCardHeader';
import Highcharts from 'highcharts';

type BuildChartOptionsParams = {
  title?: string;
  color: string;
  sortedDataItems: NameValuePair[] | NameValuePairWithSortIndex[];
  small?: boolean;
  height?: number;
  width?: number;
};

export const buildChartOptions = (
  params: BuildChartOptionsParams
): Highcharts.Options => ({
  ...baseChart,

  chart: {
    type: 'bar',
    height: params.height,
    width: params.width,
  },

  title: {
    text: params.title,
    style: {
      fontSize: params.small ? '12px' : undefined,
      fontWeight: 'bold',
    },
  },

  series: [
    {
      type: 'bar',
      dataLabels: {
        enabled: true,
        inside: params.small ? false : true,
        align: 'center',
        style: {
          textOutline: 'none',
          color: LIGHT_TEXT_PRIMARY,
          fontSize: params.small ? '8px' : SUBHEADER_FONT_SIZE,
        },
        x: params.small ? 8 : undefined,
      },
      data: params.sortedDataItems.map(dataItem => ({
        name: dataItem.name,
        y: dataItem.value,
      })),
      borderRadius: 5,
      color: params.color,
    },
  ],

  xAxis: {
    lineWidth: 0,
    gridLineWidth: 1,
    type: 'category',
    labels: {
      useHTML: false,
      style: {
        fontSize: params.small ? '8px' : SUBHEADER_FONT_SIZE,
        textOverflow: params.small ? 'none' : undefined,
        whiteSpace: 'nowrap',
        overflow: params.small ? 'none' : undefined,
      },
    },
  },

  yAxis: {
    ...baseChart.yAxis,
    labels: {
      style: {
        fontSize: params.small ? '8px' : SUBHEADER_FONT_SIZE,
      },
    },
  },
});

export const buildVisitsChart = (
  sortedDataItems: NameValuePair[],
  title?: string,
  small?: boolean,
  width?: number,
  height?: number
) =>
  buildChartOptions({
    color: CA_LIGHT_BLUE_COLOR,
    title,
    sortedDataItems,
    height,
    width,
    small,
  });
